import { defineMessages } from "react-intl";

export const orderExportDialogMessages = defineMessages({
  title: {
    id: "Yd0X8a",
    defaultMessage: "Export Orders",
    description: "export orders to csv/spreadsheet file, dialog header",
  },
  confirmButtonLabel: {
    id: "Qx5Tof",
    defaultMessage: "Export orders",
    description: "export orders to csv file, button",
  },
  allItemsLabel: {
    id: "n7yPQz",
    defaultMessage: "All orders ({number})",
    description: "export all orders to csv file",
  },
  selectedItemsLabel: {
    id: "Cf5Hs4",
    defaultMessage: "Selected orders ({number})",
    description: "export selected orders to csv file",
  },
});
